import React from 'react'
import styled from 'styled-components'

import { ThemeContext } from './ThemeContext'
import { ThemeIcon } from '../styles/darktoggle.styles'

const ToggleContainer = styled.div`
  width: 70.41px;
  height: 100%;
  display: flex;
  align-items: center;

  @media only screen and (max-width: 1300px) {
    width: 52px;
  }
`

const DarkToggle = () => {
  const { colorMode, setColorMode } = React.useContext(ThemeContext)

  if (!colorMode) {
    return <ToggleContainer></ToggleContainer>
  }

  return (
    <>
      {colorMode === 'light' ? (
        <ToggleContainer>
          <a onClick={() => setColorMode('dark')} aria-label="Light Mode">
            <ThemeIcon className="fas fa-sun"></ThemeIcon>
          </a>
        </ToggleContainer>
      ) : (
        <ToggleContainer>
          <a onClick={() => setColorMode('light')} aria-label="Dark Mode">
            <ThemeIcon className="far fa-moon"></ThemeIcon>
          </a>
        </ToggleContainer>
      )}
    </>
  )
}

export default DarkToggle
